/** Only recorded applied geometry belongs to a generation proof. Pending editor
 * intent and current account defaults must never reconstruct this projection. */
export type SolarCommittedFace = {
  polygon: unknown;
  pitchDegrees: number;
  azimuthDegrees: number;
  roofPlane?: unknown;
  appliedMounting?: unknown;
  arrayAzimuthDegrees?: number;
  appliedPlacementRules?: unknown;
  appliedRoofEdgeAnchor?: unknown;
  appliedArrayAzimuthDegrees?: number | null;
};

// Missing historical provenance is distinct from explicitly unknown provenance.
const recorded = (value: unknown) =>
  value === undefined ? { recorded: false } : { recorded: true, value };

export const solarCommittedFace = (face: SolarCommittedFace) => ({
  polygon: face.polygon,
  plane: [face.pitchDegrees, ((face.azimuthDegrees % 360) + 360) % 360],
  roofPlane: recorded(face.roofPlane),
  appliedMounting: recorded(face.appliedMounting),
  arrayAzimuthDegrees: recorded(face.arrayAzimuthDegrees),
  appliedPlacementRules: recorded(face.appliedPlacementRules),
  appliedRoofEdgeAnchor: recorded(face.appliedRoofEdgeAnchor),
  appliedArrayAzimuthDegrees: recorded(face.appliedArrayAzimuthDegrees),
});

export const solarCanonicalJson = (value: unknown): string =>
  JSON.stringify(value, (_key, entry: unknown) =>
    entry && typeof entry === 'object' && !Array.isArray(entry)
      ? Object.fromEntries(
          Object.entries(entry).sort(([a], [b]) => a.localeCompare(b))
        )
      : entry
  );

export const solarCommittedInputsFingerprint = (value: unknown): string =>
  solarCanonicalJson({ version: 2, inputs: value });

export const solarCommittedFaceFingerprint = (
  face: SolarCommittedFace
): string => solarCommittedInputsFingerprint(solarCommittedFace(face));
